import { gql } from '@apollo/client';

export const UPSERT_INSTITUTIONS = gql`
  mutation upsertInstitutions($inputs: UpsertInstitutionsInput!) {
    institution: upsertInstitutions(inputs: $inputs) {
      id
    }
  }
`;
